import React, { useState, useEffect } from "react";
import { APP_NAME } from "../constants";
import logoBase from "../images/logo/logo.png";
import sliderOne from "../images/sliders/slider-1.webp";
import sliderTwo from "../images/sliders/slider-2.webp";
import sliderThree from "../images/sliders/slider-3.webp";
import { Link } from "react-router-dom";

const HeroCarousel = () => {
  const images = [sliderOne, sliderTwo, sliderThree];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToPreviousSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section id="hero">
      <div className="home-main-container">
        <div className="carousel-container d-md-none d-none d-lg-flex">
          <div
            className="carousel-slide"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
            }}
          >
            {images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Slide ${index}`}
                className="carousel-image"
                loading="lazy"
              />
            ))}
          </div>
          <button className="carousel-control prev" onClick={goToPreviousSlide}>
            &#10094;
          </button>
          <button className="carousel-control next" onClick={goToNextSlide}>
            &#10095;
          </button>
        </div>

        <div className="container-fluid hero-overlay">
          <div className="row flex-row-reverse">
            <div className="col-md-7">
              <div className="p-5">
                <div className="card home-card">
                  <div className="card-body">
                    <div className="text-center">
                      <img src={logoBase} alt="Logo" className="home-logo" />
                      <div className="mt-3 mb-3">
                        <h2 className="main-app-title fw-bold text-uppercase">
                          {APP_NAME}
                        </h2>
                        <span className="main-app-title-fang"></span>
                      </div>
                      <div className=" text-uppercase">
                        <h4>Train your dogs</h4>
                        <h4>To Be</h4>
                        <h4>Their Best Self</h4>
                      </div>
                      <div className="mt-3">
                        <Link to="/about">
                          <button className="btn btn-custom-red">
                            About Us
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
